
function updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton)
{
    var horizontalScrollbar   = scrollableitem.scrollWidth > scrollableitem.clientWidth;

    console.log(Math.round(scrollableitem.scrollLeft));
    console.log(scrollableitem.scrollWidth);
    console.log(scrollableitem.clientWidth);

    if ( scrollableitem.scrollLeft > 0 ) 
    {
        scrollLeftButton.classList.remove( "hidden" );
    } 
    else 
    {
        scrollLeftButton.classList.add( "hidden" );
    }

    if ( horizontalScrollbar && ( Math.round(scrollableitem.scrollLeft) == ( scrollableitem.scrollWidth - scrollableitem.clientWidth ))) 
    {
        scrollRightButton.classList.add( "hidden" );
    } 
    else 
    {
        scrollRightButton.classList.remove( "hidden" );
    }

    if( scrollableitem.scrollWidth == scrollableitem.clientWidth )
    {
        scrollRightButton.classList.add( "hidden" );
        scrollLeftButton.classList.add( "hidden" );
    }
}

function initializeInfluencerScrolling( scrollableitem, scrollablearrowparent ) 
{
  
    if ( scrollableitem ) 
    {
        var scrollRightButton   = scrollablearrowparent.querySelector( ".scrollright" );
        var scrollLeftButton    = scrollablearrowparent.querySelector( ".scrollleft" );
        
         
        updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton );
        scrollRightButton.addEventListener( "click", function () 
        {
            var scrollableItemWidth = document.querySelector( ".lightning-aisle_article_item" ).clientWidth + 20;
            scrollableitem.scrollLeft += scrollableItemWidth;
            updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton );
        } );

        scrollLeftButton.addEventListener( "click", function () 
        {
            var scrollableItemWidth = document.querySelector( ".lightning-aisle_article_item" ).clientWidth + 20;
            scrollableitem.scrollLeft -= scrollableItemWidth;
            updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton );
        } );
        
        scrollableitem.addEventListener( "scroll", function() 
        {
            updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton );
        } );
    }
  }


window.addEventListener( "DOMContentLoaded", function(e)
{
    var scrollableitem  = document.querySelector( '.lightning-aisle_article_list' );     
    var scrollablearrowparent  = document.querySelector( '.lightning-influencer-arrows' );     
    initializeInfluencerScrolling( scrollableitem, scrollablearrowparent );
});